/**
 * @file Automatically generated by barrelsby.
 */

export * from './mat-icon-box-wrapper.component';
